// import {} from '@mui/material'
import msg from '@app/assets/message.svg';
import { Box, Button, Checkbox, Container, Dialog, Grid, Link, Typography } from '@mui/material';
import { PhoneField } from '@components/EditPhone/PhoneField';
import React, { FC, useEffect } from 'react';

interface EnterPhoneNumberProps {
  onChange: (phoneNumber: string) => void;
  phoneNumber?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  label?: string;
  visible: boolean;
}

export const EnterPhoneNumber: FC<EnterPhoneNumberProps> = (props) => {
  const [phoneNumber, setPhoneNumber] = React.useState(props.phoneNumber || '');
  const [saveEnabled, setSaveEnabled] = React.useState(false);
  const [phoneNumberValid, setPhoneNumberValid] = React.useState(false);
  const [agree, setAgree] = React.useState(false);

  useEffect(() => {
    if (!props.visible) {
      setAgree(false);
    }
    setSaveEnabled(agree && phoneNumberValid);
  }, [agree, phoneNumberValid, props.visible]);
  return (
    <Dialog open={props.visible} fullScreen={true}>
      <Box marginTop={5} textAlign={'center'}>
        <Grid display={'flex'} flexDirection={'column'} gap={4}>
          <Container>
            <img src={msg} alt={'message'} />
          </Container>
          <Typography color={'textPrimary'} fontSize={18} fontWeight={500}>
            Enter your mobile number to continue
          </Typography>

          <Typography
            marginLeft={4}
            marginRight={4}
            component={'p'}
            variant={'caption'}
            lineHeight={1.5}
            color={'secondary'}
            textAlign={'center'}
          >
            Enter your mobile number so we can keep you motivated and on track with your goals. We’ll send gentle
            reminders, progress updates, and occasional words of encouragemet
          </Typography>
          <Box marginTop={4} marginRight={4} marginLeft={4}>
            <PhoneField
              label={'Enter Phone Number'}
              onChange={(value, error, errorMessage) => {
                setPhoneNumberValid(!error);
                if (!error) {
                  setPhoneNumber(value);
                }
              }}
              phoneNumber={phoneNumber}
            ></PhoneField>
          </Box>
          <Box display={'flex'} flexDirection={'row'} alignItems={'flex-start'} mr={4} ml={4} padding={0}>
            <Checkbox
              sx={{ mt: 0, pt: 0 }}
              color={'primary'}
              value={agree}
              onChange={(e, checked) => {
                setAgree(checked);
              }}
            ></Checkbox>
            <Typography
              textAlign={'left'}
              lineHeight={1}
              color={'primary'}
              fontWeight={400}
              fontSize={10}
              letterSpacing={0}
              pr={2}
              pt={0.5}
            >
              I agree to receive SMS text messages from We Hate Exercise. Message frequency may vary. Message and data
              rates may apply. I understand I can opt out at any time.
            </Typography>
          </Box>
          <Box margin={4}>
            <Button
              disabled={!saveEnabled}
              variant={'contained'}
              fullWidth={true}
              color={'primary'}
              onClick={() => {
                props.onChange(phoneNumber);
              }}
            >
              Send Code
            </Button>
            <Typography lineHeight={1.5} color={'textSecondary'} variant={'caption'} fontSize={13}>
              Review Terms & Privacy Policy at <Link href={'#'}>Terms & Conditions</Link>
            </Typography>
          </Box>
        </Grid>
      </Box>
    </Dialog>
  );
};
